import { render, staticRenderFns } from "./HistoricClinic.vue?vue&type=template&id=3f425bb4"
import script from "./HistoricClinic.vue?vue&type=script&lang=js"
export * from "./HistoricClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports